import { cn } from "@/lib/utils";

export const LOGO_SRC = `${process.env.PUBLIC_URL}/xlsync-logo-primary.png`;
export const LOGO_ICON_SRC = `${process.env.PUBLIC_URL}/xlsync-icon-512.png`;

const HEIGHT = {
  sm: 48,
  md: 68,
  lg: 84,
  xl: 120,
};

/**
 * Official XLSync logo from public/xlsync-logo-primary.png (full)
 * or xlsync-icon-512.png (icon).
 *
 * @param {"sm"|"md"|"lg"|"xl"} size
 * @param {"full"|"icon"} variant
 * @param {number} height  — optional explicit height in px (overrides size)
 */
export default function XLSyncLogo({
  size = "md",
  variant = "full",
  height,
  className = "",
  ...rest
}) {
  const h = height ?? HEIGHT[size] ?? HEIGHT.md;
  const isIcon = variant === "icon";

  return (
    <img
      src={isIcon ? LOGO_ICON_SRC : LOGO_SRC}
      alt="XLSync"
      height={h}
      width={isIcon ? h : undefined}
      className={cn(
        "object-contain flex-shrink-0 rounded-md max-w-full",
        isIcon ? "aspect-square" : "w-auto",
        className
      )}
      style={{ height: h, ...(isIcon ? { width: h } : {}) }}
      {...rest}
    />
  );
}

/** @deprecated Use XLSyncLogo — kept for any legacy imports. */
export function XLSyncMark(props) {
  return <XLSyncLogo {...props} />;
}

/** @deprecated Use XLSyncLogo — wordmark is included in the PNG. */
export function XLSyncWordmark() {
  return null;
}
